import { createFileRoute } from "@tanstack/react-router";
import { MediaPage } from "../../components/media";
import { MediaType } from "../../generated/graphql";

export const Route = createFileRoute("/media/images")({
  component: ImagesPage,
});

function ImagesPage() {
  return <MediaPage mediaType={MediaType.Image} basePath="/media/images" />;
}
